import React, { useState, useRef, useEffect } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';
 
const QrCodeScanner = () => {
  const [isScanned, setIsScanned] = useState(false);
  const [isCameraAllowed, setIsCameraAllowed] = useState(false);
  const videoRef = useRef(null);
 
  useEffect(() => {
    if (isScanned) {
      localStorage.setItem("validNewCustomer", true);
      localStorage.setItem("validWithOTP", true);
      localStorage.setItem("validSalesPerson", false);
      localStorage.setItem('scannedQR', true)
      // Redirect to the scanned URL
      const scannedUrl = `${window.location.origin}/client-information`;
      window.location.href = scannedUrl;
    }
  }, [isScanned]);
 
  useEffect(() => {
    if (isCameraAllowed) {
      const codeReader = new BrowserMultiFormatReader();
      codeReader.decodeFromVideoDevice(undefined, videoRef.current, (result, error) => {
        if (result) {
          const scannedUrl = result.getText();
          if (scannedUrl === `${window.location.origin}/client-information`) {
            setIsScanned(true);
          }
        }
        if (error) {
          console.error(error);
        }
      });
 
      return () => {
        codeReader.reset();
      };
    }
  }, [isCameraAllowed]);
 
  const handleCameraPermission = () => {
    setIsCameraAllowed(true);
  };
 
  return (
    <div className="flex flex-col items-center justify-center h-screen p-4 bg-gray-100">
      {isCameraAllowed ? (
        <div className="w-full max-w-lg bg-white shadow-md rounded-lg p-4">
          {isScanned ? (
            <p className="text-green-500 text-center">QR code scanned successfully! Redirecting...</p>
          ) : (
            <div>
              <p className="text-gray-700 text-center mb-4">Scan the QR code to proceed.</p>
              <video ref={videoRef} className="w-full h-auto rounded-lg" />
            </div>
          )}
        </div>
      ) : (
        <div className="w-full max-w-md bg-white shadow-md rounded-lg p-4 text-center">
          <p className="text-gray-700 mb-4">To scan the QR code, please allow camera access.</p>
          <button
            onClick={handleCameraPermission}
            className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600"
          >
            Allow Camera
          </button>
        </div>
      )}
    </div>
  );
};
 
export default QrCodeScanner;
 